import { withLoggedOut } from '../../utils/hoc/hoc';
import ResetPassword from './components/ResetPassword/ResetPassword';

const ResetPasswordPage = () => <ResetPassword />;

export default withLoggedOut(ResetPasswordPage);
